import { Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

export function NotFound() {
  const { pathname } = useLocation();
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      mx="auto"
      mt="10em"
    >
      <Typography color="white" variant="h2" component="div">
        Woops!{' '}
      </Typography>
      <Typography color="white" variant="overline">
        Unknown Page: {pathname}
      </Typography>
    </Stack>
  );
}
